import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  root: {
    position: 'relative',
    minWidth: 140,
    padding: 10,
    backgroundColor: custom.grey[8],
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'none',
    color: custom.grey[3],
    fontWeight: 400,
    lineHeight: 1,
    textAlign: 'left',
  },
  icon: {
    color: palette.primary.main,
  },
}));
